<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family: 'OPPOSans';
  src: url('assets/Font-OPPOSans/OPPOSans-M.ttf') format('truetype'); /* 相对路径指向TTF文件 */
  font-weight: normal;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/App.vue